export const ChevronLeftIcon = ({ height = 16, width = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#0D1011"
      fillRule="evenodd"
      d="M10.353 2.313a.5.5 0 0 1 0 .707l-4.39 4.39a.833.833 0 0 0 0 1.18l4.39 4.39a.5.5 0 0 1-.707.707l-4.39-4.39a1.833 1.833 0 0 1 0-2.593l4.39-4.39a.5.5 0 0 1 .707 0"
      clipRule="evenodd"
    ></path>
  </svg>
);
